import styled from "@emotion/styled";
import LabelComponent from "@components/form/Label";
import TextInputComponent from "@components/form/TextField";
import { theme } from "@styles/theme";
import ButtonComponent from "@components/Button";
const { sm, md, lg, xl } = theme.breakpoints;
export const Container = styled.form`
  width: 100%;
  font-size: 16px;
  margin: 3em 0;
  @media (max-width: ${xl}) {
    font-size: 11px;
  }
  @media (max-width: ${lg}) {
    font-size: 14px;
  }
`;
export const Header = styled.div`
  width: 100%;
`;
export const TypeContainer = styled.div`
  width: 35%;
  display: flex;
  @media (max-width: ${md}) {
    width: 50%;
  }
  @media (max-width: ${md}) {
    width: 80%;
  }
`;
export const LabelCase = styled.div`
  width: 60%;
  background: white;
  color: #6d6d6d;
  font-family: "Poppins Regular";
  padding: 1.1em 0;
  text-align: center;
  border-top-left-radius: 0.75em;
  font-size: 0.8em;
`;
export const TypeCase = styled.div`
  width: 40%;
  background: ${(props: { color: string }) => props.color};
  color: white;
  font-family: "Poppins Regular";
  padding: 1.1em 0;
  border-top-right-radius: 0.75em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
`;

export const TypePersonContainer = styled.div`
  display: flex;
`;
export const TypePerson = styled.div`
  cursor: pointer;
  flex-grow: 1;
  text-align: center;
  background: ${(props: { selected: boolean }) =>
    props.selected ? "#90d1f4" : "#D8DDE1"};
  color: ${(props: { selected: boolean }) =>
    props.selected ? "white" : "#6D6D6D"};
  font-family: "Poppins Regular";
  padding: 0.9em;
  :last-of-type {
    border-top-right-radius: 1em;
  }
`;
export const Body = styled.div`
  width: 100%;
  padding: 2em 3em;
  background: white;
  box-sizing: border-box;
  @media (max-width: ${sm}) {
    padding: 1em;
  }
`;
export const Title = styled.div`
  color: #0085c8;
  font-family: "Poppins Medium";
  margin-bottom: 3em;
`;
export const FormSection = styled.div`
  width: 100%;
  margin: 2em 0;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(2, minmax(0, 1fr)) 0.1fr 1fr 1fr 0.1fr repeat(
      4,
      minmax(0, 1fr)
    );
  gap: 2em 1em;
  grid-template-areas:
    "name name . lastname lastname  .  doctype doctype document document "
    "birthday birthday . etnia etnia . eps eps eps .  "
    "service service service service service service service . . .";
  @media (max-width: ${lg}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-areas:
      "name name lastname lastname"
      "doctype  document eps eps "
      " etnia etnia  birthday birthday"
      "service service service service";
  }
  @media (max-width: ${md}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-areas:
      "name name lastname lastname"
      "doctype  doctype document document"
      "eps eps birthday birthday"
      " etnia etnia  etnia  etnia"
      "service service service service";
  }
  @media (max-width: ${sm}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "name"
      "lastname"
      "doctype"
      "document"
      "eps"
      "birthday"
      "etnia"
      "service";
  }
`;
export const FormGroup = styled.div`
  grid-area: ${({ area }: { area: string }) => area};
  position: relative;
`;
export const Label = styled(LabelComponent)`
  position: relative;
  color: #6d6d6d;
  display: flex;
  flex-direction: column;
  font-family: "Poppins Regular";
`;
export const TextField = styled(TextInputComponent)`
  margin: 0.5em 0;
  border-radius: 0.5em;
  border: #a2a2a2 solid 1px;
  font-family: "Poppins Regular";
  font-size: 0.9em;
  background-color: #f8f8f8;
  color: hsl(0, 0%, 50%);
`;
export const TitleService = styled.div`
  color: #a7a7a7;
  font-family: "Poppins Ligth";
  font-size: 0.9em;
`;
export const Error = styled.div`
  position: absolute;
  top: 100%;
  font-family: Poppins Ligth;
  color: red;
`;
export const ErrorAreas = styled.div`
  position: absolute;
  top: 110%;
  font-family: Poppins Ligth;
  color: red;
  @media (max-width: ${sm}) {
    top: 102%;
  }
`;
export const ServiceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Fotter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 3em;
  @media (max-width: ${lg}) {
    flex-wrap: wrap;
  }
`;
export const Instruction = styled.div`
  width: 46%;
  text-align: center;
  font-family: Poppins Ligth;
  font-size: 0.7em;
  color: #90d1f4;
  @media (max-width: ${lg}) {
    width: 100%;
    margin-bottom: 2.5em;
  }
`;
export const CurrentStep = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins Ligth;
  color: #0085c8;
  margin-right: 1em;
`;
export const Loading = styled.div`
  width: 7em;
  height: 0.5em;
  background-color: #e5e5e5;
`;
export const CurrentState = styled.div`
  width: 50%;
  background: #0085c8;
  height: 100%;
  border-radius: 0.5em;
`;
export const Button = styled(ButtonComponent)`
  margin: 0 2em;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
`;
/*export const Fotter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 3em;
  @media (max-width: ${lg}) {
    flex-wrap: wrap;
  }
`;
export const Instruction = styled.div`
  width: 46%;
  text-align: center;
  font-family: Poppins Ligth;
  font-size: 0.7em;
  color: #90d1f4;
  @media (max-width: ${md}) {
    width: 100%;
    margin-bottom: 2em;
  }
`;
export const CurrentStep = styled.div`
  padding: 0 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins Ligth;
  color: #0085c8;
`;
export const Loading = styled.div`
  width: 7em;
  height: 0.5em;
  background-color: #e5e5e5;
`;
export const CurrentState = styled.div`
  width: 25%;
  background: #0085c8;
  height: 100%;
  border-radius: 0.5em;
`;
export const Button = styled(ButtonComponent)`
  margin: 0 2em;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  @media (max-width: ${lg}) {
    margin-right: 0;
  }
`;*/
